import type { ReactNode } from 'react';

import { useEffect, useState } from 'react';

import clientApi from 'api/clientApi';
import { PUBLIC_URL } from 'utility/env';
import { setApplicationEnvTarget } from 'redux/actions/appEnv';
import { useAppDispatch } from 'redux/storeConfig/store';

type ApiClientConfig = {
  apiUrl: string;
  envTarget: string;
};

export default function ApiClientWrapper({ children }: { children: ReactNode }) {
  const [apiConfig, setApiConfig] = useState<ApiClientConfig | null>(null);
  const [hasLoadedConfig, setHasLoadedConfig] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    async function fetchApiConfig() {
      try {
        const response = await fetch(`${PUBLIC_URL}/config.json`);
        const json = await response.json();

        setApiConfig(json as ApiClientConfig);
        setHasLoadedConfig(true);
      } catch (_e) {
        setHasLoadedConfig(true);
      }
    }

    fetchApiConfig();
  }, []);

  useEffect(() => {
    if (hasLoadedConfig && apiConfig) {
      if (apiConfig.apiUrl) {
        clientApi.defaults.baseURL = apiConfig.apiUrl;
      }

      if (apiConfig.envTarget) {
        dispatch(setApplicationEnvTarget(apiConfig.envTarget));
      }
    }
  }, [hasLoadedConfig, apiConfig, dispatch]);

  return <>{hasLoadedConfig && children}</>;
}
